import { CommonModule } from "@angular/common";
import { Component, inject, input } from "@angular/core";

import { COUNTRY } from "@hermes/core-app-core";
import { Country, isKorea } from "@hermes/locale";
import { SrOnlyNoSnippetDirective } from "@hermes/utils-generic-directives-sr-only-no-snippet";

import { KoreanLegalLinksComponent } from "../korean-legal-links/korean-legal-links.component";

@Component({
    selector: "h-footer-copyright",
    imports: [
        CommonModule,
        SrOnlyNoSnippetDirective,
        KoreanLegalLinksComponent,
    ],
    templateUrl: "./footer-copyright.component.html",
    styleUrls: ["./footer-copyright.component.scss"],
})
export class FooterCopyrightComponent {
    #country = inject<Country>(COUNTRY);

    public hasLightCopyright = input<boolean>();

    public isKorea = isKorea(this.#country);

    public year = new Date().getFullYear();
}
